import React from "react";
import MainRoutes from "./Routes";
import "src/App.scss";
import {ToastContainer} from "react-toastify";
import {AuthProvider} from "src/Lib/Provider/RACT_authProvider";
import {GlobeProvider} from "src/Lib/Provider/RACT_globProvider";
import {SrvSetProvider} from "src/Lib/Provider/RACT_srvSetProvider";

/**
 * @desc step:1002 Creating react application, using providers.
 *       use dyna (AuthProvider, Globe, Profile)
 *
 * @returns {JSX.Element}
 * @constructor
 */
function App() {
    return (
        <div className="App">
            <AuthProvider>
                <GlobeProvider>
                    <SrvSetProvider>
                        <MainRoutes/>
                        <ToastContainer
                            position={'bottom-right'}
                            theme={'colored'}
                            autoClose={5000}
                            pauseOnHover={true}
                        />

                    </SrvSetProvider>
                </GlobeProvider>
            </AuthProvider>
        </div>
    );
}



export default App;
